import * as jQuery from "jquery";
import { flushSync } from "react-dom";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { FocusTextAreaWithoutScrolling } from "source/app/presentation/Shared/Form/TextArea/JournalCaptureTextArea/Helpers/JournalCaptureTextAreaHelpers";
import { IBottomBarState } from "../../IBottomBarState";

export const ToggleQuickJournal = () => {
    const bottomBar = State.ReadClass<IBottomBarState>(
        ESharedComponent.BottomBar
    );

    if (!bottomBar) {
        return;
    }

    const newState = !bottomBar.state.showQuickJournal;

    flushSync(() => {
        bottomBar.setState({
            showQuickJournal: newState,
        });
    });

    if (newState === true) {
        const quickJournalTextArea = document.getElementById(
            "quickJournalTextArea_target"
        ) as HTMLTextAreaElement | null;

        FocusTextAreaWithoutScrolling(quickJournalTextArea);
        Sounds.metallicSliding.Play();
    } else {
        Sounds.metallicClosing.Play();
    }
};
